import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const container = document.getElementById('root') as HTMLElement;
const app = <React.StrictMode><App /></React.StrictMode>;

// Public pages contain the same React markup before JavaScript loads.
// Development, the game, and the custom 404 use a fresh client render.
if (container.dataset.prerendered === 'true') {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}
